import React, { useState, useEffect } from 'react';
import api from '../api';
import { format } from 'date-fns';

export const Kyc = () => {
  const [kycRequests, setKycRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchKyc();
  }, []);

  const fetchKyc = async () => {
    try {
      const response = await api.get('/admin/kyc/pending');
      setKycRequests(response.data.data?.kycSubmissions || []);
    } catch (error) {
      console.error(error);
      setKycRequests([
        { id: 'usr_1', firstName: 'Alice', lastName: 'Williams', email: 'alice@example.com', documentType: 'PASSPORT', submittedAt: new Date().toISOString() }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleReview = async (userId, status) => {
    try {
      await api.put(`/admin/kyc/${userId}/review`, { status });
      fetchKyc();
    } catch (err) {
      console.error(err);
      alert('Failed to update KYC status');
    }
  };

  return (
    <div>
      <h1 className="page-title">KYC Review Queue</h1>

      <div className="glass">
        <div className="table-container" style={{ border: 'none', borderRadius: '16px' }}>
          {loading ? (
            <div className="loader-container"><div className="spinner"></div></div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>User</th>
                  <th>Email</th>
                  <th>Document Type</th>
                  <th>Submitted At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {kycRequests.map(req => (
                  <tr key={req.id || req._id}>
                    <td style={{ fontWeight: 500 }}>{req.firstName} {req.lastName}</td>
                    <td style={{ color: 'var(--text-secondary)' }}>{req.email}</td>
                    <td>{req.documentType || 'ID Card'}</td>
                    <td style={{ color: 'var(--text-secondary)' }}>
                      {req.submittedAt ? format(new Date(req.submittedAt), 'MMM dd, yyyy') : 'N/A'}
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button className="btn-success" onClick={() => handleReview(req.id || req._id, 'APPROVED')}>Approve</button>
                        <button className="btn-danger" onClick={() => handleReview(req.id || req._id, 'REJECTED')}>Reject</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {kycRequests.length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', padding: '32px', color: 'var(--text-secondary)' }}>
                      No pending KYC requests.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};
